import React, { Component } from "react";
import Input from "./input";
import Select from "./select";

export default class Form extends Component {
  state = {
    data: {},
    errors: {},
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.doSubmit();
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;

    this.setState({ data, errors });
  };

  renderSelect(name, label, options, onChange = this.handleChange) {
    const { data } = this.state;

    return (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={onChange}
      />
    );
  }

  renderInput(
    name,
    label,
    type = "text",
    autoComplete = null,
    disabled = false,
    placeholder = "",
    onChange = this.handleChange,
    headerTextColor = "white"
  ) {
    const { data } = this.state;

    return (
      <Input
        type={type}
        name={name}
        value={data[name]}
        label={label}
        disabled={disabled}
        autoComplete={autoComplete}
        placeholder={placeholder}
        onChange={onChange}
        headerTextColor={headerTextColor}
      />
    );
  }
}
